<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formAddOrigin" @submit="submitForm($event, 'addOrigin')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'addOrigin',
                    fieldName:'origin'
                })"
                :placeholder="$t('enter_a_origin')"
                :value.sync="$v.forms.addOrigin.origin.$model"
                :label="$t('origin')"

            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.addOrigin._loading"
            >
                <span>{{ $t('add_origin') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm('formAddOrigin')" :loading="forms.addOrigin._loading">
                {{ $t("add_origin") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import ButtonLoading from '~/components/ButtonLoading.vue';

/** Mixins */
import formMixin from '~/mixins/form';
import modalComponentMixin from '~/mixins/modalComponent';

/** Others */
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators"
export default {
    name: "ProviderAddOriginModal",
    mixins: [
        formMixin, 
        validationMixin,
        modalComponentMixin
    ],
    components: {
        ButtonLoading
    },
    data(){
        return {
            forms:{
                addOrigin:{
                    origin:null,
                    _loading: false
                },
            },
            provider: null
        }
    },
    validations:{
        forms:{
            addOrigin:{
                origin:{
                    required
                }
            }
        }
    },

    watch:{
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForms();
                this.$v.$reset();
            }
        },
        dataComponent(){
            if(this.dataComponent.provider)
                this.provider = this.dataComponent.provider;
        }
    },

    methods:{
        async submitForm(e, formName){
            e.preventDefault();
            await this.sendForm({ 
                formName , 
                url: `/providers.api/groups/${this.provider.uuid}/origins/create`,

            });
            this.showComponent = false;
            this.$emit('submit',formName);
        }
    }
};
</script>

<style>
</style>